import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form"];

  connect() {
    // Auto-submit the form on field changes
    this.formTarget.addEventListener("change", this.autoSubmit.bind(this));
  }

  autoSubmit(event) {
    const formData = new FormData(this.formTarget);

    const method =
      this.formTarget.querySelector("input[name='_method']")?.value || "POST";

    fetch(this.formTarget.action, {
      method: method.toUpperCase(),
      body: formData,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json",
      },
      credentials: "same-origin",
    })
      .then((response) => {
        if (response.ok) {
          console.log(`[auto_save_form_controller] Saved`);
        }
      })
      .catch((error) => {
        console.error("[auto_save_form_controller] Error:", error);
      });
  }
}
